import { Box, MenuItem, Select, styled } from "@mui/material"

export const DropdownFilterContainer = styled(Box)(() => ({
  padding: "5px 0px",
  marginLeft: "12px",
}))

export const StyledSelect = styled(Select)(() => ({
  height: "40px",
  width: "230px",
  fontSize: "14px",
  marginTop: "5px",
  backgroundColor: "#FFFFFF",
}))

export const StyledMenuItem = styled(MenuItem)(() => ({
  width: "210px",
  fontSize: "14px",
  borderRadius: "5px",
  margin: "3px 11px",
  minHeight: "40px",
  whiteSpace: "normal",
}))
